
<div v-if="state.isVisible" @click.self="close" @keyup.esc="close" :id="processID"
     tabindex="-1" class="context-menu-mask v-modal">
  <div :style="style"
       ref="contextMenu"
       :class="classes"
       class="context-menu">
    <slot></slot>
  </div>
</div>
